import React, { ReactNode, useState } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { ThemeContext, themeContextDefaults } from "../context/themeContext";
import { ThemeProps } from "../models/theme";
import { createTenantMuiTheme } from "../config/theme";

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<ThemeProps>(themeContextDefaults.theme);

  const clearData = () => {
    setTheme(themeContextDefaults.theme);
  };

  const updateTheme = (data: any) => {
    setTheme((prev) => ({ ...prev, ...data }));
  };

  const value = React.useMemo(
    () => ({
      theme,
      clearData,
      updateTheme,
    }),
    [theme]
  );

  const muiTheme = React.useMemo(() => {
    return createTenantMuiTheme(theme?.color_primary, theme?.color_secondary);
  }, [theme?.color_primary, theme?.color_secondary]);

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

